import { Component, inject, TemplateRef} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SweetServices } from 'src/services/sweet.services';
import { AppComponent } from '../app.component';
import { LoginService } from '../../services/login/login.service';
import { User } from '../model/session/user.model';
import { SessionSotrageService } from '../../services/session-sotrage.service';
import { ComunicacionService } from '../../services/comunicacion.service';
import { HomeService } from 'src/services/home/home.service';
import { Helper } from 'src/app/common/Helper/Helper';
import { LoadingService } from '../services/loading.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  selectedLanguage = environment.lang;
  public mostrarPassword: boolean = false;
  public lang: string = environment.lang;
  public traduccion = environment.traduccion;
  private loadingService = inject(LoadingService)

  loginForm = {
    Login: '',
    Password: '',
    Bloqueo: false,
    version: environment.version
  };
 
  constructor(private translateService: TranslateService,
              private router: Router,
              private alerta: SweetServices,
              private loginService: LoginService,
              private ssservice: SessionSotrageService,
              private comunicacionService: ComunicacionService) {
    this.translateService.setDefaultLang(this.selectedLanguage);
    const browserLang = translateService.getBrowserLang();
    translateService.use(browserLang.match(/es|en|fr|pt/) ? browserLang : this.selectedLanguage);
    translateService.use(this.selectedLanguage);
    this.comunicacionService.setLenguaje(this.selectedLanguage);
  }

  //Tener en cuenta más adelante formLogin al no usarse
  submitLogin(evt: Event) {
    evt.preventDefault()
    this.loadingService.mostrar();
    if (this.formularioInValido()) {
      this.loadingService.ocultar();
      this.alerta.AlertaErrorTimer('Llena el Formulario');
    } else {
      this.loginService.iniciarSesion(this.loginForm).subscribe(response => {
        if (response === null) {
          this.loadingService.ocultar();
          this.alerta.AlertaError(
            'Existe un error, si persiste contacte al administrador del Sitio.'
          );
        } else if (response.isCorrect === 'false') {
          this.loadingService.ocultar();
          this.alerta.AlertaError(response.message);
        } else {
          this.ssservice.setPasswordSession(this.loginForm.Password);
          this.correctLogin(response.data.info.result);
          this.ssservice.setlstActividadVulnerable(response.data?.info?.result?.lstActividadVulnerable ?? 0);
        }
      }, (err) => {
        this.loadingService.ocultar();
        this.alerta.AlertaCatch(err);
      }
      );
    }

  }

  formularioInValido():boolean {
    return (this.loginForm.Login === '' || this.loginForm.Password === '');
  }

  private correctLogin(data: User) {
    this.ssservice.setCurrentSession(data);
    var message = data.recordatorioCaducidad? data.mensajeCaducidad:'';
    var header = data.recordatorioCaducidad 
      ? 'Actualizar contraseña'
      :'Ingrese su nueva contraseña';
    var confirmMessage = data.recordatorioCaducidad 
      ? 'Acceso Confirmado...'
      :'Operación realizada con éxito.';
    if (data.primeraVez) {
      this.loadingService.ocultar();
      this.alerta.AlertaCambioPassword(
        data.usuarioId, 
        this.router, 
        message, 
        header, 
        confirmMessage
      );
    } else if(data.recordatorioCaducidad){
      this.loadingService.ocultar();
      this.router.navigate(['/v2']);
      this.alerta.AlertaCambioPassword(
        data.usuarioId, 
        this.router, 
        message, 
        header, 
        confirmMessage
      );
    }else {
      this.loadingService.ocultar();
      this.router.navigate(['/v2/search-profile']);
    }
  }

  toogleLanguage(lang: string) {
    this.translateService.use(lang);
    this.lang = lang;
    this.comunicacionService.setLenguaje(lang);
  }

  togglePassword() {
    this.mostrarPassword = !this.mostrarPassword;
  }  

  prevenirPegado(evt: Event) {
    if(environment.production){
      evt.preventDefault();
    }
  }
}
